import { useMemo, useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import { onRequestError } from 'services/handlers';

import { PatientStipendWorklistApi } from '../../../../../api';
import { stipendStatuses, stipendStatusMap, STP_APPROVED, STP_DENIED } from '../constants';

export default function StatusChangeDropdown({ row, onChangeSuccess }) {
  const { id: reimbursementId } = row;
  const [saving, setSaving] = useState(false);

  const allowedStatuses = useMemo(function() {
    return stipendStatuses
      .filter(function({ id }) {
        return [STP_APPROVED, STP_DENIED].includes(id);
      })
      .map(function(value) {
        return prepareStatus({ ...value });
      });
    function prepareStatus(value) {
      return value;
    }
  }, []);

  return (
    <Select
      value={row.status}
      disableUnderline={true}
      size="small"
      variant="standard"
      disabled={saving}
      fullWidth
      renderValue={value => stipendStatusMap[value]}
      onChange={statusOnChange}
    >
      {allowedStatuses.map(e => (
        <MenuItem key={e.id} value={e.id} disabled={e.disabled}>
          {e.name}
        </MenuItem>
      ))}
    </Select>
  );

  function statusOnChange({ target }) {
    const status = target.value;

    setSaving(true);
    PatientStipendWorklistApi.updateRow(reimbursementId, {
      status
    })
      .then(function({ data }) {
        onChangeSuccess(data);
      })
      .catch(onRequestError)
      .finally(() => setSaving(false));
  }
}
